'use strict';/* global define */define('modules/feedback/components/feedback-history-navigation/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$state", "$scope", "$rootScope", "Modals", "ng"];
function controller($state,$scope,$rootScope,Modals,ng){// jshint validthis:true
// jshint latedef:false
var index;var ctrl=this;var max=0;ctrl.go=go;$rootScope.$broadcast('currentUserContext',ctrl.user);$scope.$watch('$ctrl.current',function(currentId){currentId=+currentId;if(ctrl.histogram.$promise){ctrl.histogram.$promise.then(function(data){_setMax(data);index=_periodIndex(data,currentId);_setChronos();}).catch(Modals.fail);}else{_setMax(ctrl.histogram);index=_periodIndex(ctrl.histogram,currentId);_setChronos();}});// ---
/**
     * Navigate to the selected period
     *
     * @param  {Number} periodId - selected period id
     */function go(periodId){if(ctrl.isRouted&&periodId){$state.go('.',{periodId:periodId});}else{if(periodId){ctrl.current=periodId;}if(ctrl.isRouted){$state.go('^');}}}function previous(){return index?ctrl.histogram[index-1]:null;}function current(){return ctrl.histogram[index];}function next(){return index<max?ctrl.histogram[index+1]:null;}/**
     * Initilise the history time traveler
     */function _setChronos(){ctrl.previousPeriod=previous();ctrl.currentPeriod=current();ctrl.nextPeriod=next();}/**
     * Get period position
     *
     * @param  {Array} dataset - list of periods
     * @param  {Number} id     - selected period id
     *
     * @return {Number}        - index position of the selected period
     */function _periodIndex(dataset,id){var index=-1;ng.forEach(dataset,function(period,i){if(period.id===+id){index=i;}});return index;}/**
     * Set the limit
     *
     * @param {Array} dataset - list of periods
     */function _setMax(dataset){if(!dataset){max=0;}else{max=Math.max(dataset.length-2,0);}}}module.exports=controller;});
